"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var react_form_with_constraints_1 = require("react-form-with-constraints");
var FormGroup = (function (_super) {
    __extends(FormGroup, _super);
    function FormGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.reRender = _this.reRender.bind(_this);
        return _this;
    }
    FormGroup.prototype.componentWillMount = function () {
        this.context.form.addValidateEventListener(this.reRender);
    };
    FormGroup.prototype.componentWillUnmount = function () {
        this.context.form.removeValidateEventListener(this.reRender);
    };
    FormGroup.prototype.reRender = function (input) {
        var fieldName = this.props.for;
        if (input.name === fieldName) {
            this.forceUpdate();
        }
    };
    FormGroup.prototype.className = function (fieldName) {
        var className = 'form-group';
        if (fieldName !== undefined) {
            var form = this.context.form;
            if (form.fieldsStore.containErrors(fieldName)) {
                className += ' has-danger';
            }
            else if (form.fieldsStore.containWarnings(fieldName)) {
                className += ' has-warning';
            }
            else if (form.fieldsStore.areValidDirtyWithoutWarnings(fieldName)) {
                className += ' has-success';
            }
        }
        return className;
    };
    FormGroup.prototype.render = function () {
        var _a = this.props, fieldName = _a.for, className = _a.className, children = _a.children, divProps = __rest(_a, ["for", "className", "children"]);
        var classes = className !== undefined ? className + " " + this.className(fieldName) : this.className(fieldName);
        return (React.createElement("div", __assign({}, divProps, { className: classes }), children));
    };
    FormGroup.contextTypes = {
        form: PropTypes.object.isRequired
    };
    return FormGroup;
}(React.Component));
exports.FormGroup = FormGroup;
var FormControlLabel = function (props) {
    var className = props.className, children = props.children, labelProps = __rest(props, ["className", "children"]);
    var classes = className !== undefined ? className + " form-control-label" : 'form-control-label';
    return (React.createElement("label", __assign({}, labelProps, { className: classes }), children));
};
exports.FormControlLabel = FormControlLabel;
var FormControlInput = (function (_super) {
    __extends(FormControlInput, _super);
    function FormControlInput(props) {
        var _this = _super.call(this, props) || this;
        _this.reRender = _this.reRender.bind(_this);
        return _this;
    }
    FormControlInput.prototype.componentWillMount = function () {
        this.context.form.addValidateEventListener(this.reRender);
    };
    FormControlInput.prototype.componentWillUnmount = function () {
        this.context.form.removeValidateEventListener(this.reRender);
    };
    FormControlInput.prototype.reRender = function (input) {
        var fieldName = this.props.name;
        if (input.name === fieldName) {
            this.forceUpdate();
        }
    };
    FormControlInput.prototype.className = function (name) {
        var className = 'form-control';
        if (name !== undefined) {
            var form = this.context.form;
            if (form.fieldsStore.containErrors(name)) {
                className += ' form-control-danger';
            }
            else if (form.fieldsStore.containWarnings(name)) {
                className += ' form-control-warning';
            }
            else if (form.fieldsStore.areValidDirtyWithoutWarnings(name)) {
                className += ' form-control-success';
            }
        }
        return className;
    };
    FormControlInput.prototype.render = function () {
        var _a = this.props, innerRef = _a.innerRef, className = _a.className, children = _a.children, inputProps = __rest(_a, ["innerRef", "className", "children"]);
        var classes = className !== undefined ? className + " " + this.className(inputProps.name) : this.className(inputProps.name);
        return (React.createElement("input", __assign({ ref: innerRef }, inputProps, { className: classes })));
    };
    FormControlInput.contextTypes = {
        form: PropTypes.object.isRequired
    };
    return FormControlInput;
}(React.Component));
exports.FormControlInput = FormControlInput;
var FieldFeedbacks = function (props) {
    var className = props.className, children = props.children, other = __rest(props, ["className", "children"]);
    var classes = className !== undefined ? className + " form-control-feedback" : 'form-control-feedback';
    return React.createElement(react_form_with_constraints_1.FieldFeedbacks, __assign({}, other, { className: classes }), children);
};
exports.FieldFeedbacks = FieldFeedbacks;
var LabelWithFormControlStyle = (function (_super) {
    __extends(LabelWithFormControlStyle, _super);
    function LabelWithFormControlStyle(props) {
        var _this = _super.call(this, props) || this;
        _this.reRender = _this.reRender.bind(_this);
        return _this;
    }
    LabelWithFormControlStyle.prototype.componentWillMount = function () {
        this.context.form.addValidateEventListener(this.reRender);
    };
    LabelWithFormControlStyle.prototype.componentWillUnmount = function () {
        this.context.form.removeValidateEventListener(this.reRender);
    };
    LabelWithFormControlStyle.prototype.reRender = function (input) {
        var fieldNames = this.props.for;
        if (fieldNames.includes(input.name)) {
            this.forceUpdate();
        }
    };
    LabelWithFormControlStyle.prototype.render = function () {
        var _a = this.props, fieldNames = _a.for, style = _a.style, children = _a.children, labelProps = __rest(_a, ["for", "style", "children"]);
        var form = this.context.form;
        var brandDanger = '#d9534f';
        var brandWarning = '#f0ad4e';
        var brandSuccess = '#5cb85c';
        var color;
        if ((_b = form.fieldsStore).containErrors.apply(_b, __spread(fieldNames))) {
            color = brandDanger;
        }
        else if ((_c = form.fieldsStore).containWarnings.apply(_c, __spread(fieldNames))) {
            color = brandWarning;
        }
        else if ((_d = form.fieldsStore).areValidDirtyWithoutWarnings.apply(_d, __spread(fieldNames))) {
            color = brandSuccess;
        }
        var styles = style !== undefined ? __assign({ color: color }, style) : { color: color };
        return (React.createElement("label", __assign({}, labelProps, { style: styles }), children));
        var _b, _c, _d;
    };
    LabelWithFormControlStyle.contextTypes = {
        form: PropTypes.object.isRequired
    };
    return LabelWithFormControlStyle;
}(React.Component));
exports.LabelWithFormControlStyle = LabelWithFormControlStyle;
//# sourceMappingURL=Bootstrap4.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-form-with-constraints-bootstrap4/lib/Bootstrap4.js
// module id = 1067
// module chunks = 0